import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as messageActions from '../../../../../actions/chat/messageActions'
import BrowserHistory from "../../../../../providers/BrowserHistory";
import './message.css';
import PlaceholderThumb from '../../../../thumb/PlaceholderThumb';

import FaArrowCircleODown from 'react-icons/lib/fa/arrow-circle-o-down'

var Buffer = require('buffer/').Buffer

class Message extends Component {
  constructor(props) {
    super(props);
    this.requestFile = this.requestFile.bind(this);
  }

  state = {
    downloading: false
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.el.type !== 'file') return
    if (!this.state.downloading) return

    let tmp = nextProps.files.filter(a => {
      return (a.fileName === this.props.el.fileName && a.p === '100.0%')
    })
    //console.log(nextProps.files,this.props.el.fileName )
    if (tmp.length > 0) {
      //console.log(tmp[0])
      var blob = new Blob([Buffer.concat(tmp[0].buff)])
      const fileObjectURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = fileObjectURL
      link.download = this.props.el.fileCaption
      link.style.display = "none"
      //link.setAttribute('download', this.props.el.fileCaption)
      document.body.appendChild(link);
      link.click()
      document.body.removeChild(link);
      this.setState({ downloading: false })
    }
  }

  requestFile = () => {
    this.props.el.type === 'file' &&
      (this.state.downloading ? (
        this.setState({ downloading: false }),
        this.props.messagesFileCancel({
          fileName: this.props.el.fileName
        })
      ) : (
          this.setState({ downloading: true }),
          this.props.messagesFileRequest({
            fileName: this.props.el.fileName
          })
        ))

  }

  goToCalendar = (entryId) => {
    BrowserHistory.push(`/main/calendar/${entryId}`)
  }

  render() {
    const senderType = this.props.contact.id === this.props.sender ? 1 : 2
    const messageType = this.props.el.type
    let p = '0%'
    if (this.props.el.type === 'file' && this.state.downloading) {
      let tmp = this.props.files.filter(a => {
        return (a.fileName === this.props.el.fileName)
      })
      if (tmp.length > 0) p = tmp[0].p
    }

    let message = this.props.message;
    console.log('propsFromMessage', this.props)

    if (messageType === 'file') {
      message = (
        <div className="message-attachment">
          {this.state.downloading ?
            [
              <div key="0" className="loading"></div>,
              <div key="1">{p}</div>
            ] :
            <FaArrowCircleODown className="icon" />
          }
          <div className="filename">{this.props.el.fileCaption}</div>
        </div>
      );
    }

    if (messageType === 'calendar') {
      message = (
        <div onClick={() => this.goToCalendar(this.props.el.eventId)} style={{ cursor: "pointer" }}>
          {this.props.message}
        </div>
      )
    }

    return (

      <div onClick={this.requestFile} className="modalBodyMessageContainer">
        <div className={senderType === 1 ? "modalBodyMessage" : "modalBodyOwnMessage"}>
          {senderType === 1 ?
            [<div key="0" name="image">
              <div>
                {
                  this.props.contact.profile_photo_url ? <img src={this.props.contact.profile_photo_url} /> 
                  :
                  <div className="default-image" style={{border: 'none'}}>
                    <PlaceholderThumb
                      firstName={this.props.contact.first_name}
                      lastName={this.props.contact.last_name}
                      size={15}
                      contactDefaultPhoto={this.props.contact.color}
                    />
                  </div>
                }
              </div>
            </div>, <div key="1" name="triangle"></div>]
            : ""}
          <div name="message-container">
            {message}
          </div>
        </div>
        <div name="message-time">
          {this.props.time}
        </div>
      </div>


    )
  }
}

const mapStateToProps = (state) => {
  return {
    files: state.attachmentReducer.files
  }
}

const mapDispatchToProps = {
  messagesFileRequest: messageActions.messagesFileRequest,
  messagesFileCancel: messageActions.messagesFileCancel
}

export default connect(mapStateToProps, mapDispatchToProps)(Message)


// WEBPACK FOOTER //
// ./src/common/chat/modalWindow/modalWindowBody/message/message.js